import { useTranslation } from 'react-i18next';

export function useFormattedTitle(location: string, siteName: string) {
  const { t } = useTranslation('common');

  const startsWithThe = siteName.trim().toLowerCase().startsWith('the');

  const rawTitle = t(location, { siteName });

  return startsWithThe ? rawTitle.replace('a ', '') : rawTitle;
}
